import React, { Component, useContext, useEffect, useState } from 'react';
import withAuthorization from '../auth/session/withAuthorization';
import AuthUserContext from '../auth/session/context';
import FirebaseContext from '../auth/firebase/context';
import RadarChart from '../components/RadarChart';
import DonutChart from '../components/DonutChart';
// import LineChart from'../components/LineChart';
import BarChart from '../components/BarChart';
import styles from '../css/Dashboard.module.css';
import dimension from '../css/Dimension.module.css';

import Tabs from '../components/Tabs';


const Dashboard = Component => {
    const auth = useContext(AuthUserContext);
    const firebase = useContext(FirebaseContext);
    const [rawData, setRawData] = useState([]);
    const [rawLikeData, setLikeData] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        firebase
            .getSurveyData(auth.project)
            .onSnapshot((querySnapshot) => {
                let allDocs = querySnapshot.data().data;
                setRawData(...rawData, allDocs);
            })
                
        firebase
            .likes(auth.project)
            .onSnapshot((querySnapshot) => {
                let total = querySnapshot.data().total;
                let likes = querySnapshot.data().likes;
                let dislikes = total - likes;
                setLikeData(...rawLikeData, [likes, dislikes])
                setLoaded(true);
            })
    }, []);

    return (
        <>
            {rawData.length <= 0 && loaded && 
                <div className={styles.noData}><h3>There is no data yet</h3></div>
            }

            {rawData.length > 0 &&
                <div className={styles.module}>

                    <div className={styles.overview}>
                        <h2>UX Overview {auth.project}</h2>
                        <p>Latest 10 responses</p>
                        <RadarChart className={styles.radarChart} data={rawData} />
                        <div className={styles.dataInfo}>
                            <p>Total number of survey responses: {rawData.length}</p>
                            {rawLikeData.length > 0 && <DonutChart data={rawLikeData} />}
                        </div>
                    </div>
                    <div className={styles.distributionView}>
                        <h2>Response score distribution</h2>
                        <p>Latest 10 responses</p>
                        <Tabs>
                            <div label="Appealing Visual Design" className={dimension.one}>
                                <h3>Appealing Visual Design</h3>
                                <BarChart data={rawData} dimension={1} />
                            </div>
                            <div label="Communicated Information Structure" className={dimension.two}>
                                <h3>Communicated Information Structure</h3>
                                <BarChart data={rawData} dimension={2} />
                            </div>
                            <div label="Visual Branding" className={dimension.three}>
                                <h3>Visual Branding</h3>
                                <BarChart data={rawData} dimension={3} />
                            </div>
                            <div label="Mastery" className={dimension.four}>
                                <h3>Mastery</h3>
                                <BarChart data={rawData} dimension={4} />
                            </div>
                            <div label="Outcome Satisfaction" className={dimension.five}>
                                <h3>Outcome Satisfaction</h3>
                                <BarChart data={rawData} dimension={5} />
                            </div>
                            <div label="Emotional Attachment" className={dimension.six}>
                                <h3>Emotional Attachment</h3>
                                <BarChart data={rawData} dimension={6} />
                            </div>
                            <div label="Task Effectiveness" className={dimension.seven}>
                                <h3>Task Effectiveness</h3>
                                <BarChart data={rawData} dimension={7} />
                            </div>
                            <div label="Task Efficiency" className={dimension.eight}>
                                <h3>Task Efficiency</h3>
                                <BarChart data={rawData} dimension={8} />
                            </div>
                            <div label="Stability &amp; Performance" className={dimension.nine}>
                                <h3>Stability &amp; Performance</h3>
                                <BarChart data={rawData} dimension={9} />
                            </div>
                        </Tabs>
                    </div>
                </div>
            }
        </>
    );

}

const condition = authUser => !!authUser;

export default withAuthorization(condition)(Dashboard);